import { render, staticRenderFns } from "./EmbedCodeTab.vue?vue&type=template&id=64a8e265&scoped=true"
import script from "./EmbedCodeTab.vue?vue&type=script&lang=ts"
export * from "./EmbedCodeTab.vue?vue&type=script&lang=ts"
import style0 from "./EmbedCodeTab.vue?vue&type=style&index=0&id=64a8e265&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a8e265",
  null
  
)

export default component.exports